import React from 'react';

const AWS_EBS_vs_S3 = () => {
  return (
    <div>
      <h1>AWS_EBS_vs_S3</h1>
      <p>This is the AWS_EBS_vs_S3 component.</p>
    </div>
  );
};

export default AWS_EBS_vs_S3;
